import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUpdateTimesheetDeadlineRequestFailure() {
      return getState().request.isFailure;
    },
    isUpdateTimesheetDeadlineRequestPending() {
      return getState().request.isPending;
    },
    isUpdateTimesheetDeadlineRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
